import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client, throwFriendlyApiError } from '../common';
import type { AuthTokenResponse } from './use-create-customer';

type Variables = { phone: string; otp: string };

export const useVerifyOtp = createMutation<
  AuthTokenResponse,
  Variables,
  AxiosError
>({
  mutationFn: async ({ phone, otp }) =>
    client({
      url: 'v2/login/otp/verify',
      method: 'POST',
      data: { phone, otp },
    })
      .then((response) => response.data)
      .catch((err: any) => throwFriendlyApiError(err, 'verify code')),
});
